/* global isAuth, Base64, UPLOAD_FILS, useGosKey */
var hasPlugin = 0;
var thumbPrint;
var certDialogCallback;

// CAPICOM constants ?
var CAPICOM_STORE_OPEN_READ_ONLY = 0;
var CAPICOM_CURRENT_USER_STORE = 2;
var CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
var CAPICOM_CERTIFICATE_FIND_EXTENDED_PROPERTY = 6;
var CAPICOM_CERTIFICATE_FIND_TIME_VALID = 9;
var CAPICOM_CERTIFICATE_FIND_KEY_USAGE = 12;
var CAPICOM_DIGITAL_SIGNATURE_KEY_USAGE = 0x00000080;
var CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
var CAPICOM_INFO_SUBJECT_SIMPLE_NAME = 0;
var CAPICOM_ENCODE_BASE64 = 0;
var CAPICOM_E_CANCELLED = -2138568446;
var CERT_KEY_SPEC_PROP_ID = 6;

function signAllProto() {
	var table = document.getElementById("prototable");
	if (!table) {
		aAlert("No table!");
		return;
	}
	var tds = new Array();
	$(".prottd").each(function (n, td) {
		tds[tds.length] = td;
	});
	var current = 0;
	var errors = 0;

	var sigBtn = document.getElementById("sigBtn");
	//if (sigBtn)
	//sigBtn.setAttribute("disabled", true);

	function processTd(td) {
		var lot = td.getAttribute("lot");
		var rtd = document.getElementById("rtd" + lot);
		if ($("input[name=replaced" + lot + "]").val()) {
			//измененный файл
			if (current === tds.length - 1) {
				$("#waitDialog").dialog("close");
				document.getElementById("protoform").submit();
			} else {
				current++;
				processTd(tds[current]);
			}
		} else {
			var href = document.getElementById("a" + lot).href + "&base64";
			document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "Подписываем протокол №" + (current + 1) + "...";
			document.getElementById("protolog").scrollTop = 99999999;

			$("#waitDialog").dialog("open");
			$.ajax(href, ({
				"async": true,
				"timeout": 30000,
				success: function (data) {
					if (data === "noauth") {
						aAlert("Ошибка сессии! Необходима авторизация!").then(() => {
							showPostAuthDialog();
						});
						return;
					}
					Sign(data, true, true, function (sign) {
						if (!sign) {
							aAlert("Ошибка при подписывании протоколов!!!").then(() => {
								$("#waitDialog").dialog("close");
							});
							return;
						}
						document.getElementById("sign" + lot).value = sign;
						document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "Готово!<br>";
						document.getElementById("protolog").scrollTop = 99999999;
						if (current === tds.length - 1) {
							$("#waitDialog").dialog("close");
							document.getElementById("protoform").submit();
						} else {
							current++;
							processTd(tds[current]);
						}
					}, true);
				},
				error: function (data) {
					document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "ОШИБКА ПОЛУЧЕНИЯ!<br>";
					document.getElementById("protolog").scrollTop = 99999999;
					errors++;
					if (errors > 10) {
						aAlert("Ошибка при подписывании протоколов!").then(() => {
							$("#waitDialog").dialog("close");
						});

					} else {
						processTd(tds[current]);
					}


				}
			}));
		}
	}
	processTd(tds[current]);
//	});

}

/**
 * Подпись шаблона документа по нажатию на кнопку (onclick)
 * Происходит посредством 2-ух ajax запросов. Первый - получаем документ с сервера в виде base64. Второй - отправляем подпись
 * Используется только в черновике
 * @param {type} name - путь до документа
 * @param {type} inp - кнопка подписи
 * @param {type} callback - колбек при усешной подписи
 * @returns {undefined|Boolean}
 */
function signFixedDoc(name, inp, callback) {
	var td = findParentByClassName(inp, 'fixedSign');
	if (!td) {
		aAlert("err 07");
		return;
	}
	var href = "SignTools?op=getfixed&name=" + encodeURIComponent(name);

	// успешная подпись
	function successSign(data, callback) {
		$("input.sf_value", td).val(data.file_id); // для инпута скрытого даем id файла
		$(".fixedSignBtn", td).hide(); // прячем кнопку подписать
		$(".fixedSignInfo", td).html(data.file_info); // текст вставляем
		//$("a[data-signer]", fixedSignInfo).attr("onclick", `show_sign(${data.file_id}, false); return false`); // открываем через signedobjectid

		if (callback) {
			callback();
		}
	}

	$.ajax(href, ({// первый ajax - получение документа который нужно подписать (бинарное содержимое)
		"async": true,
		"timeout": 10000,
		success: function (data) {
			if (useGosKey) { // если подпись через Госключ
				var fileInfo = getFileInfoFromName(name);
				if (!fileInfo.gosKeyAllowed) {
					aAlert("Подписание данного типа документа не поддерживается Госключем");
					return;
				}
				var dt = new DataTransfer();

				var bstr = atob(data);
				var length = bstr.length;
				var u8arr = new Uint8Array(length);
				while (length--) {
					u8arr[length] = bstr.charCodeAt(length);
				}
				var file = new File([u8arr], name.toGoskeyFileName(), {type: fileInfo.type});
				dt.items.add(file);
				SignGosKeyFiles(dt.files, function (signData) {
					for (var i = 0; i < dt.files.length; i++) {
						var filename = dt.files[i].name.toGoskeyFileName();
						var sign = signData[filename];
						if (!sign) {
							aAlert("Ошибка при подписывании документа!!!").then(() => {
								$("#waitDialog").dialog("close");
							});
							return;
						}
						var formData = new FormData();
						formData.append("sign", sign);
						formData.append("op", "savefixed");
						formData.append("name", name);
						formData.append("useGosKey", "true");
						$.ajax({// второй ajax  - отправка полученной подписи с использованием госключа
							type: 'POST',
							url: "SignTools",
							data: formData,
							cache: false,
							contentType: false,
							processData: false,
							success: function (data, textStatus, jqXHR) {
								if (!data || !data.file_id) {
									aAlert("Ошибка 38!");
									clearStoredCertificate(); // сбрасываем последний использованный сертификат
									return;
								}

								successSign(data, () => {
									if (callback) {
										callback(name, data);
									}
								});
							},
							error: function (data) {
								aAlert("Ошибка!!!!");
								clearStoredCertificate(); // сбрасываем последний использованный сертификат
							}
						});
					}
				});
			} else {
				Sign(data, true, true, function (sign) { // подпись через квалифицированную подпись
					if (!sign) {
						aAlert("Ошибка при подписывании документа!!!").then(() => {
							$("#waitDialog").dialog("close");
						});
						return;
					}
					var formData = new FormData();
					formData.append("sign", sign);
					formData.append("op", "savefixed");
					formData.append("name", name);
					$.ajax({// второй ajax  - отправка полученной подписи без использования госключа
						type: 'POST',
						url: "SignTools",
						data: formData,
						cache: false,
						contentType: false,
						processData: false,
						success: function (data, textStatus, jqXHR) {
							if (!data) {
								aAlert("Ошибка 37!!");
								clearStoredCertificate(); // сбрасываем последний использованный сертификат
								return;
							}
							if (!data.file_id) {
								aAlert("Ошибка 38!");
								clearStoredCertificate(); // сбрасываем последний использованный сертификат
								return;
							}

							successSign(data, () => {
								if (callback) {
									callback(name, data);
								}
							});
						},
						error: function (data) {
							aAlert("Ошибка!!!!");
							clearStoredCertificate(); // сбрасываем последний использованный сертификат
						}
					});
				}, true);
			}
		},
		error: function (data) {
			aAlert("Ошибка!!");
			clearStoredCertificate(); // сбрасываем последний использованный сертификат
		}
	}));
	return false;
}

/* global isie */
function activeXObject(name) {
	try {
		if (isie) {
			// IE
			try {
				return new ActiveXObject(name);
			} catch (e) {
				aAlert("Невозможно создать ActiveX объект '" + name + "'! Пожалуйста, добавьте данный сайт в доверенную зону в настройках безопастности Internet Explorer!");
				console.log(e.message);
				return false;
			}

		} else {
			// FF
			return new GeckoActiveXObject(name);
		}
	} catch (e) {
		aAlert("Невозможно создать ActiveX объект '" + name + "'!");
		console.log(e.message);
		return false;
	}
}



function GetErrorMessage(e)
{
	var err = e.message;
	if (!err) {
		err = e;
	} else if (e.number) {
		err += " (0x" + decimalToHexString(e.number) + ")";
	}
	return err;
}

function decimalToHexString(number) {
	if (number < 0) {
		number = 0xFFFFFFFF + number + 1;
	}

	return number.toString(16).toUpperCase();
}

/* global browser, Conf */
function ObjCreator(name) {
	if (!checkPlugin())
		return false;
	try {
		switch (browser) {
			case 'ie':
				return new ActiveXObject(name);
			default:
				var cadesobject = document.getElementById('cadesplugin_object');
				return cadesobject.CreateObject(name);
		}
	} catch (err) {
		aAlert("Невозможно создать объект '" + name + "'!");
	}
}

function checkPlugin() {
	return hasPlugin;
}
async function checkGosKey() {
	return useGosKey || false;
//	var response = await jQuery.ajax("/ajax/api/getInfo?act=usegoskey");
//	if (response !== null && typeof response === "object") {
//		return response.data[0].usegoskey === true;
//	}
//	return false;
}

function pluginDialog(force) {
	if (force) {
		$(".librow").hide();
		$(".librow." + browser).show();
		activateJSdialog('.pluginDialog');
		if (sessionStorage) {
			sessionStorage.setItem("plugin-dialog-seen", "true");
		}
	}
	isMobile && $(".noMobile").hide() && $('.isMobile').show();
}

function getSubjPartSurname(SN) {
	var rv = SN.replace(/(.+,\s|^)SN=(.*?)(,\s.*|$)/, "$2"); // SURNAME
	return rv == SN ? "" : rv;
}
function getSubjPartGivenname(SN) {
	var rv = SN.replace(/(.+,\s|^)G=(.*?)(,\s.*|$)/, "$2"); // GIVENNAME
	return rv == SN ? "" : rv;
}
function getSubjPartFIO(SN) {
	var rv = SN.replace(/(.+,\s|^)CN=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartEmail(SN) {
	var rv = SN.replace(/(.+,\s|^)E=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartLoc(SN) {
	var rv = SN.replace(/(.+,\s|^)L=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartOrg(SN) {
	var rv = SN.replace(/(.+,\s|^)O=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartDolzh(SN) {
	var rv = SN.replace(/(.+,\s|^)T=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartAddress(SN) {
	var rv = SN.replace(/(.+,\s|^)S=(.*?)(,\s.*|$)/, "$2");
	return rv == SN ? "" : rv;
}
function getSubjPartInn(SN) {
	var rv = SN.replace(/(.+,\s|^)(INNLE|OID.1.2.643.100.4|ИНН ЮЛ)=(.*?)(,\s.*|$)/, "$3");
	if (rv != SN) {
		return rv;
	}

	var rv = SN.replace(/(.+,\s|^)(ИНН|INN)=(.*?)(,\s.*|$)/, "$3");
	if (rv != SN) {
		if (rv.length === 12 && rv.substring(0, 2) === "00") {
			rv = rv.substring(2);
		}
		return rv;
	}
	return "";
}

async function signSendForm(data, formId, onSignCallback) {
	var useGosKey = await checkGosKey();
	var dt;
	if (useGosKey) {
		dt = new DataTransfer();
	}

	var form = document.getElementById(formId);
	if (!form) {
		aAlert("No form!");
		return;
	}
	if (!form.sign) {
		aAlert("Bad form!");
		return;
	}

	if (typeof (UPLOAD_FILS) !== "undefined" && !UPLOAD_FILS.isDone()) {
		aAlert("Дождитесь окончание загрузки файлов.");
		return false;
	}
	async function mainSign() {
		if (useGosKey) {
			//data = jQuery(data).text().replaceAll("\t", "").replace(/(\n)+/gi, "\n").trim();
			const formName = $(form).attr("data-form-name") ? $(form).attr("data-form-name") : "Форма заявки";
			const formFile = formName + ".txt";
			var sign2names = [];
			for (var n = 2; n < 99; n++) {
				console.log('FA', n, form, $(form).attr);
				FA = $(form).attr;
				FORM = form;
				if (typeof $(form).attr("data-sign" + n + "-text") === "undefined") {
					break;
				}
				const signfilename = $(form).attr("data-sign" + n + "-name") ? $(form).attr("data-sign" + n + "-name") + ".txt" : "text_" + n + ".txt";
				sign2names[n] = signfilename;
			}
			ssn = sign2names;

			var file = new File([data], formFile, {type: "text/plain"});
			dt.items.add(file);

			const attachedFiles = {};

			// Прикрепленные файлы к форме (нужно подписать дополнительно)
			var attachFilesInput = form.querySelector("input[name='attach_files']");
			if (attachFilesInput !== null && attachFilesInput !== void 0) {
				var fileIds = attachFilesInput.value;
				if (fileIds.length > 0) {
					var arrayIds = fileIds.split(",");
					for (let i = 0; i < arrayIds.length; i++) {
						const fileId = arrayIds[i];
						// Находим все элементы с классом attfile new
						var attFileElements = form.querySelectorAll(".attfile.new");
						for (let j = 0; j < attFileElements.length; j++) {
							const attFile = attFileElements[j];
							const attFileInput = attFile.querySelector(`input[type="hidden"][value="${fileId}"]`);
							if (!attFileInput) {
								continue;
							}
							const fileLink = attFile.querySelector(".filecap .title");
							if (fileLink) {
								const fileUrl = fileLink.getAttribute("href");
								const fileName = fileLink.textContent.trim();
								try {
									const response = await fetch(fileUrl);
									const blob = await response.blob();
									// Определяем MIME тип
									const mimeType = blob.type || "text/plain";
									// Создаем File объект
									const file = new File([blob], fileName, {type: mimeType});
									// Добавляем в DataTransfer
									dt.items.add(file);
									if (attachedFiles.hasOwnProperty(fileName)) {
										await aAlert("ГосКлюч не поддерживает подписание нескольких файлов с идентичными названиями. Переименуйте файл " + fileName + ".");
										return;
									}
									attachedFiles[fileName] = fileId;
								} catch (e) {
									console.error(`Ошибка при загрузке файла ${fileName}:`, e);
								}

							}
							break;
						}
					}
				}
			}
			SignGosKeyFiles(dt.files, function (signData) {
				for (var i = 0; i < dt.files.length; i++) {
					var filename = dt.files[i].name.toGoskeyFileName();
					if (filename === formFile) {
						form.sign.value = signData[filename];
					} else if (attachedFiles.hasOwnProperty(filename)) {
						var fileId = attachedFiles[filename];
						if (typeof form["sign_attach_file_" + fileId] === "undefined") {
							form.appendChild(mkInput("_attach_file_" + fileId));
						}
						form["sign_attach_file_" + fileId].value = signData[filename];
					} else {
						for (var n = 2; n < 99; n++) {
							if (filename === sign2names[n]) {
								if (typeof form["sign" + n] === "undefined") {
									form.appendChild(mkInput(n));
								}
								form["sign" + n].value = signData[filename];
							}
						}
					}
				}
				if (typeof form.useGosKey === "undefined") {
					var input = document.createElement("INPUT");
					input.type = "hidden";
					input.name = "useGosKey";
					input.value = "true";
					form.appendChild(input);
				}

				if (typeof onSignCallback === "function") {
					onSignCallback();
				} else {
					form.onsubmit = "";
					form.submit();
				}
			});
			return;
		}
		Sign(data, false, false, function (signedData) {
			if (!signedData)
				return false;
			form.sign.value = signedData;
			if (typeof onSignCallback === "function") {
				onSignCallback();
			} else {
				form.onsubmit = "";
				form.submit();
			}
		}, useSelectedSign);
	}

	function mkInput(fn) {
		if (typeof fn === "undefined") {
			fn = n;
		}
		var input = document.createElement("INPUT");
		input.type = "hidden";
		input.name = "sign" + fn;
		return input;
	}

	function signNext() {
		n++;
		console.log("signNext", n);
		var sign2text = $(form).attr("data-sign" + n + "-text");
		if (typeof sign2text === "undefined") {
			//нет доп подписи, сразу подписываем основную форму
			mainSign(n - 1);
		} else {
			console.log('sign2', n, sign2text);
			if (sign2text) {
				//есть доп подпись (цена в заявке), сначала подписываем ее, потом подписываем основную форму
				if (useGosKey) {
					const filename = $(form).attr("data-sign" + n + "-name") ? $(form).attr("data-sign" + n + "-name") + ".txt" : "text_" + n + ".txt";

					var file = new File([sign2text], filename, {type: "text/plain"});
					dt.items.add(file);
					signNext();
					return;
				}
				Sign(sign2text, false, false, function (signedData) {
					if (!signedData) {
						return false;
					}
					if (typeof form["sign" + n] === "undefined") {
						form.appendChild(mkInput());
					}
					form["sign" + n].value = signedData;
					useSelectedSign = true;
					signNext();
				}, useSelectedSign);
			} else {
				signNext();
			}
		}
	}

	var n = 1;
	var useSelectedSign = false;

	signNext();
}

/**
 * Подпись формы/файла
 * @param {type} txtDataToSign - текст для подписи
 * @param {type} isFile - файл или текстовое сообщение
 * @param {type} isBase64 - если данные уже закодированы в base64 или false для простых сообщений
 * @param {type} callback  - Вызовется после успешной подписи. Внутрь передается подпись (sign), которую отправляем на бек (например в signFixedDoc делаем форму и отправляем ajax с подписью)
 * @param {type} useSelectedCert - использовать последний выбранный сертификат (не показывать диалог выбора повторно)
 * @param {type} forceSignType - тип подписи (если не указан то -1)
 * @param {type} snils - СНИЛС пользователя для подписи через ГосКлюч (используется когда forceSignType === 2 или когда useGosKey === true)
 * @returns {undefined|Boolean}
 */
async function Sign(txtDataToSign, isFile, isBase64, callback, useSelectedCert, forceSignType, snils) {

	if (typeof forceSignType === "undefined") {
		forceSignType = -1;
	}
	// госключ
	if (forceSignType !== 1 && (true === useGosKey || forceSignType === 2 || forceSignType === 3 || forceSignType === 4)) {
		if (isFile) {
			await aAlert("Ошибка формировании подписи: sign type");
			return;
		}
		var dt = new DataTransfer();
		var fileName = (txtDataToSign.includes("\n") ? "Сообщение" : txtDataToSign);
		if (!fileName.endsWith(".")) {
			fileName = fileName + ".";
		}
		fileName = fileName + "txt";
		var file = new File([txtDataToSign], fileName.toGoskeyFileName(), {type: "text/plain"});
		dt.items.add(file);
		return SignGosKeyFiles(dt.files, function (signData) {
			callback(signData[fileName.toGoskeyFileName()]);
		}, snils);
	}
	// Электронная подпись
	if (!checkPlugin()) {
		pluginDialog(1);
		return false;
	}
	return SignAsync(txtDataToSign, isFile, isBase64, callback, useSelectedCert);
}

var lastUsedCert; // последний использованный сертификат в глобальной переменной
async function SignAsync(txtDataToSign, isFile, isBase64, callback, useSelectedCert) {
	isFile = !!isFile;
	try {
		var cert;
		if (lastUsedCert && useSelectedCert) { // если есть последний выбранный сертификат и флаг true
			cert = lastUsedCert;
		} else {
			cert = await getSignCert();  // иначе открываем диалог с выбором сертификата
		}

		if (!cert) {
			$(".sign-test-form .sc-2").removeClass("checking").addClass("sign-test__image_fail");
			return null;
		}

		$(".sign-test-form .sc-2").removeClass("checking").addClass("sign-test__image_checked");

		lastUsedCert = cert; // обновляем последний использованный сертификат

		$(".signCover").show();
		//FillCertInfo_Async(cert);
		var errormes = "";
		try {
			var oSigner = await cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
		} catch (err) {
			errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
			throw errormes;
		}
		if (oSigner) {
			await oSigner.propset_Certificate(cert);
		} else {
			errormes = "Failed to create CAdESCOM.CPSigner";
			throw errormes;
		}
		var oSignedData = await cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

		if (!isFile) {
			if (!isBase64) {
				await oSignedData.propset_ContentEncoding(0);
			} else {
				await oSignedData.propset_ContentEncoding(1);
				txtDataToSign = base64_encode(txtDataToSign);
			}
		} else {
			if (!isBase64)
				txtDataToSign = base64_encode(txtDataToSign);
			await oSignedData.propset_ContentEncoding(1);
		}


		const CADES_BES = 1;
		const TSP_FLAG = 5;

		// Данные на подпись ввели
		var Signature;
		try {

			var oLicense = await cadesplugin.CreateObjectAsync("CAdESCOM.CPLicense");
			var isTspValid = await oLicense.IsValid(cadesplugin.CADESCOM_PRODUCT_TSP);

			await oSignedData.propset_Content(txtDataToSign);
			await oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN

			const sign_tsp_on_client = Conf.get("sign_tsp_on_client");

			if (sign_tsp_on_client && isTspValid && (new Date).getTime() - (localStorage.getItem('tsp_last_timeout') ?? 0) > Conf.get("sign_tsp_disable_time_ms")) {
				await oSigner.propset_TSAAddress(Conf.get("sign_tsp_server"));

				const timeoutPromise = new Promise((resolve) =>
					setTimeout(() => resolve('timeout'), Conf.get("sign_tsp_timeout_ms"))
				);
				const res = await Promise.race([oSignedData.SignCades(oSigner, TSP_FLAG | CADES_BES, isFile), timeoutPromise]);
				if (res === 'timeout') {
					console.warn("ERROR TSP");
					localStorage.setItem('tsp_last_timeout', (new Date).getTime());
					const signMessageText = document.getElementById('signMessageText');
					if (signMessageText) {
						signMessageText.innerHTML = 'Ждем ответ от сервера штампов времени...';
					}
				} else {
					Signature = res;
				}
			}

			if (!Signature) {
				Signature = await oSignedData.SignCades(oSigner, CADES_BES, isFile);
			}

		} catch (err) {
			debugger;
			errormes = cadesplugin.getLastError(err);
			if (errormes.includes('0x80072EE7') || errormes.includes('0x80072F87')) {
				localStorage.setItem('tsp_last_timeout', (new Date).getTime());
				Signature = await oSignedData.SignCades(oSigner, CADES_BES, isFile);
				if (!Signature) {
					throw errormes;
				}
			} else {
				throw errormes;
			}
		}

		//alert(Signature);
		$(".signCover").hide();
		if (typeof callback === "function") {
			callback(Signature);
		}
		return Signature;

	} catch (exception) {
		SIGE = exception;
		console.error("SIGN ERR", exception);
		console.trace();
		const errmsg = typeof exception === "object" ? exception.message : exception;
		var msg;
		if (errmsg.includes('0x000004C7')) {
			//user cancel
			return;
		}


		if (errmsg.includes('0x80072EE7') || errmsg.includes('0xC2100124') || errmsg.includes('0xC2100100')) {
			//Не удается разрешить имя или адрес сервера (0x80072EE7)
			msg = 'Ошибка обращения к серверу штампов времени. Пожалуйста, повторите попытку!';
			localStorage.setItem('tsp_last_timeout', (new Date).getTime());
		}

		if (errmsg.includes('0x80072F87')) {
			//Прокси
			msg = 'Ошибка сценария автоматической настройки прокси сервера. Пожалуйста, повторите попытку!';
			localStorage.setItem('tsp_last_timeout', (new Date).getTime());
		}
		if (errmsg.includes('0x800B0109')) {
			//Цепочка сертификатов обработана, но обработка прервана на корневом сертификате, у которого отсутствует отношение доверия с поставщиком доверия.
			msg = 'Ошибка при формировании подписи! Корневой сертификат не установлен в доверенные!<br>Попробуйте обновить плагин КриптоПро по&nbsp;<a rel="nofollow" target="_blank" href="https://m-ets.ru/static/cadesplugin.exe">ссылке</a>';
		}
		if (!msg) {
			msg = 'Ошибка при формировании подписи! <br>Попробуйте обновить плагин КриптоПро по&nbsp;<a rel="nofollow" target="_blank" href="https://m-ets.ru/static/cadesplugin.exe">ссылке</a>';
		}
		await aAlert(msg);
		$(".sign-test-form .sc-3").removeClass("checking").addClass("sign-test__image_fail");
		clearStoredCertificate();
		$(".signCover").hide();
		return;
	}

}


function prf(name) {
	if (window.prf_time) {
		console.info("PROFILER", performance.now() - window.prf_time, name);
	}
	window.prf_time = performance.now();
}

/**
 * Диалог с выбором сертификата
 * @returns {cert} - выбранный сертификат или null - если не закрыли окно или не нашлись сертификаты
 */
async function getSignCert() {
	var dialog = aCreateDialog('.signDialog', '');

	dialog.showDialog();

	const $status = $('.certSel_loader', dialog);
	var dateObj = new Date();

	var lgcrts = [];
	var certs = [];
	var listedCerts = [];
	var found = 0;
	var breakFound = false;
	var storedSelectedCertsV2;

	try {
		storedSelectedCertsV2 = JSON.parse(localStorage.getItem('__storedSelectedCertsV2'));
		if (storedSelectedCertsV2 === null || isArray(storedSelectedCertsV2)) {
			throw new Error();
		}
	} catch (exception) {
		storedSelectedCertsV2 = {};
		localStorage.setItem('__storedSelectedCertsV2', JSON.stringify(storedSelectedCertsV2));
	}

	var store_auth_user_id = auth_user_id ? auth_user_id : "unauth";
	var storedCert = storedSelectedCertsV2[store_auth_user_id];


	var sertItemDummy = jQuery("<label class='certificat-item dummy'></label>");
	var container = jQuery("<div class='certificat-cont'></div>");
	var title = jQuery("<div class='sert-title'><span class='loading-spoiler'>XXXXXXXXXXXXXXXXXXXXXX</span></div>");
	var body = jQuery('<div class="sert-info"><div class="rert-row loading-spoiler"><div class="title">Действителен до:</div><div class="value">01.01.2047</div></div><div class="rert-row loading-spoiler"><div class="title">ИНН:</div><div class="value">000000000000</div></div></div>');
	jQuery(sertItemDummy)
		.append(jQuery(container).append(title).append(body));
	jQuery('.certSel_listCert', dialog).append(sertItemDummy);

	if (storedCert) {
		//есть старый, будем ждать его

		$(".button_visibleCertList", dialog).show().on("click", function () {
			storedCert = null;
			$(".button_visibleCertList", dialog).addClass('transparent');
			$(".certificat-item", dialog).show();
			if (!$('.certificat-item input[type="radio"]:checked', dialog).is(":first-child")) {
				//если он не первый, переносим в начало
				$('.certificat-item input[type="radio"]:checked', dialog).parents(".certificat-item").insertBefore($(".certificat-item", dialog).first());
			}
			sertItemDummy.remove();
		});

	}

	function initScroll() {
		jQuery('.scrollbar-mets', dialog).scrollbar({
			"autoScrollSize": true
		});
	}


	function status(s) {
		if (s === true) {
			$('.loader', dialog).hide();
			$('.certLoadInfo', dialog).html('');
		} else {
			$('.certLoadInfo', dialog).html(s);
		}
	}

	async function addCertFromStore(oStore, name, num) {
//		await sleep(1000);
		if (breakFound) {
			return;
		}
		var all_certs = await oStore.Certificates;
		var cert;
		var certCnt = (await all_certs.Count);

		var first, last;
		if (!num) {
			first = 1;
			last = certCnt;
		} else {
			num = parseInt(num);
			first = num;
			last = num;
		}

		if (first > certCnt) {
			return;
		}

		for (var i = first; i <= last; i++) {
			if (breakFound) {
				return;
			}
			cert = await all_certs.Item(i);

			var thumb = await cert.Thumbprint;
			if (listedCerts[thumb]) {
				//уже добавили
				continue;
			}
			listedCerts[thumb] = true;


			var hasPrivateKey = await cert.HasPrivateKey();
			if (!hasPrivateKey) {
				continue;
			}

			var SN = await cert.SubjectName;
			var certDate = new Date((await cert.ValidToDate));
			const daysLeft = (certDate - dateObj) / 1000 / 3600 / 24;
			if (daysLeft > 365 * 3 && typeof cert.Extensions !== 'undefined') {
				//больше трех лет, пароверяем доп поля
				console.info('больше трех лет, пароверяем доп поля');
				try {
					var extensions = await cert.Extensions();
					var extensions_cnt = await extensions.Count;

					for (var x = 1; x <= extensions_cnt; x++) {
						var ext = await extensions.Item(x);
						var oid = await ext.OID;
						var oid_val = await oid.Value;
						if (oid_val === "2.5.29.16") {
							var data = await ext.EncodedData;
							var value = await data.Value();
							var str = atob(value);
							var dateTimeStr = str.substr(21, 15);
							const isoDateTimeStr = `${dateTimeStr.slice(0, 4)}-${dateTimeStr.slice(4, 6)}-${dateTimeStr.slice(6, 8)}T${dateTimeStr.slice(8, 10)}:${dateTimeStr.slice(10, 12)}:${dateTimeStr.slice(12, 14)}Z`;
							certDate = new Date(isoDateTimeStr);
						}
					}
				} catch (Ex) {
					//ну и ладно
				}
			}
			if (dateObj >= certDate) {
				continue;
			}
			var fio = getSubjPartFIO(SN);
			var loc = getSubjPartLoc(SN);
			var org = getSubjPartOrg(SN);
			var dolzh = getSubjPartDolzh(SN);
			var inn = getSubjPartInn(SN);
			var sdate = certDate.format("yyyy.mm.dd");

			var snum = 'serianDummy';
			var udcen = 'ucDummy';

			prf('getStrings');

			var txt = (fio ? fio + (org ? ", " + dolzh + " " + org : "") + (loc ? ", " + loc : "") + (inn ? ", ИНН " + inn : "") : SN) + " (до " + certDate.format("dd.mm.yyyy") + ")";
			cinfo = {title: fio, inn: inn, subj: SN, sn: snum, uc: udcen, td: sdate, cert: cert};
			lgcrts.push(cinfo);

			if (dateObj < certDate && hasPrivateKey /*&& IsValid*/) {
				found++;
				certs[thumb] = cert;
				var radio = jQuery("<input type='radio' name='sign_select' />")
					.attr("data-date", certDate.format("dd.mm.yyyy"))
					.attr("data-store", name)
					.attr("data-num", i)
					.val(thumb);

				radio.on("change", function () {
					$(".container-button__dalee", dialog).removeAttr("disabled").focus();
				});
				var sertItem = jQuery("<label class='certificat-item'></label>").on("click", function (ev) {
					$("input", ev.currentTarget).prop("checked", true);
					$(".container-button__dalee", dialog).removeAttr("disabled").focus();
				});
				var container = jQuery("<div class='certificat-cont'></div>");
				var title = jQuery("<div class='sert-title'></div>").html(fio);
				var body = jQuery("<div class='sert-info'></div>");

				function addBR(cap, val) {
					if (val) {
						jQuery("<div class='rert-row'><div class='title'>" + cap + ":</div><div class='value'>" + val + "</div></div>").appendTo(body);
					}
				}

//				addBR("Организация", org);
//				addBR("Должность", dolzh);
				addBR("Действителен до", certDate ? certDate.format("dd.mm.yyyy") : null);
				addBR("ИНН", inn);
//				addBR("Издатель", udcen);

				jQuery(sertItem)
					.append(radio)
					.append(jQuery(container).append(title).append(body));

				jQuery('.certSel_listCert', dialog).append(sertItem);

				$(".button_visibleCertList span", dialog).html("(" + found + ")");

				if (storedCert) {
					if (storedCert.thumb !== thumb) {
						sertItem.hide();
					} else {
						sertItemDummy.remove();
						sertItem.click();
					}
				} else {
					sertItemDummy.remove();
				}
			}
		}
	}

//	if (!storedThumb) {
	initScroll();
//	}

	var selectedAsyncCertDate;

	selectedAsyncCert = await new Promise(async function (resolve, reject) {

		dialog.on("click", function (e) {
			//e.preventDefault();
			e.stopPropagation();
			if (e.target === $(".cancel", dialog)[0] || (e.target === this || e.target === dialog.find(".modal-pure__close")[0])) {
				dialog.closeDialog();
				breakFound = true;
				resolve(false);
			}
		});

		$(".container-button__dalee", dialog).click(function () {
			var val = $('input[name="sign_select"]:checked', dialog).val();
			const input = $('input[name="sign_select"]:checked', dialog);
			selectedAsyncCertDate = input.attr('data-date');
			if (!val) {
				aAlert("Сертификат не выбран!");
			} else {
				$(".dialog2__wrapper").removeClass("active");
				$(".dialog2__wrapper, .dialog2_close").off("click");

				breakFound = true;

				//сохраняем в локальном хранилище сертификат
				storedSelectedCertsV2[store_auth_user_id] = {thumb: val, store: input.attr('data-store'), num: input.attr('data-num')};
				localStorage.setItem('__storedSelectedCertsV2', JSON.stringify(storedSelectedCertsV2));


				resolve(val);
			}
		});

		try {


			var oStoreUser;
			var oStoreStore;

			if (storedCert) {
				status('Поиск ранее выбранного сертификата...');
				if (storedCert.store === "user") {
					oStoreUser = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");
					await oStoreUser.Open();
					await addCertFromStore(oStoreUser, "user", storedCert.num);
				}
				if (storedCert.store === "store") {
					oStoreStore = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");
					await oStoreStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
					await addCertFromStore(oStoreStore, "store", storedCert.num);
				}
			}



			status('Поиск сертификатов пользователя...');
			if (!oStoreUser) {
				oStoreUser = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");
				await oStoreUser.Open();
			}
			await addCertFromStore(oStoreUser, "user");

			if (!oStoreStore) {
				status('Поиск съемных носителей...');
				oStoreStore = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");
				oStoreStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
			}
			status('Поиск сертификатов на съемных носителях...');
			await addCertFromStore(oStoreStore, "store");
			status(true);

			if (found === 0) {
				await aAlert('Сертификаты не найдены!<br><p>Вам необходимо установить УКЭП, запустив приложение КриптоПро CSP.<br><span style="display: block; margin-top: 5px;">В приложении выбираем:<br><b>"Сервис"</b> → <b>"Просмотреть сертификаты в контейнере"</b> → <b>"Обзор"</b>.<br>Затем необходимо выбрать Ваш сертификат, нажать <b>"Далее"</b> и <b>"Установить"</b></span></p>');
				resolve(false);
			}

			if (found === 1) {
				$(".certificat-item", dialog).click();
				$(".button_visibleCertList", dialog).addClass('transparent');
			}

			if (sertItemDummy.is(":visible")) {
				$(".button_visibleCertList", dialog).click();
			}


			Promise.resolve().then(async () => {
				try {
					if (isAuth && (new Date()).getTime() - localStorage.getItem("lgcrt") > 3600000) {
						for (const ci of lgcrts) {
							ci.uc = getSubjPartFIO(await ci.cert.IssuerName);
							ci.sn = await ci.cert.SerialNumber;
							delete ci.cert;
						}
						var b = btoa(encodeURIComponent(JSON.stringify(lgcrts)));
						console.log(JSON.stringify(lgcrts));
						jQuery.post("lgcrt", "b=" + browser + "&l=" + b);
						localStorage.setItem("lgcrt", (new Date()).getTime());
					}
				} catch (exception) {
				}
			});


		} catch (exception) {
			dialog.closeDialog();
			reject(exception);
		}
	});

	dialog.closeDialog();

	if (!selectedAsyncCert) { // если закрыли диалог или сертификаты не найдены, то null
		return null;
	}

	cert = certs[selectedAsyncCert]; // из всех сертификатов возвращаем тот, что выбран

	if (typeof selectedCertInfo !== undefined) {
		//данные для отображения в проверке подписи
		const subjName = await cert.SubjectName;

		selectedCertInfo = {// объект с данными сертификата для отображения в окне проверки подписи
			subject: {
				name: getSubjPartFIO(subjName),
				org: getSubjPartOrg(subjName),
				dolzh: getSubjPartDolzh(subjName),
				inn: getSubjPartInn(subjName),
				address: getSubjPartAddress(subjName),
				fio: (getSubjPartSurname(subjName) + " " + getSubjPartGivenname(subjName)).trim()
			},
			issuer: getSubjPartFIO(await cert.IssuerName),
			snum: await cert.SerialNumber,
			date: selectedAsyncCertDate
		};

	}

	return cert;
}

async function signUploadedFile(id) {
	console.log("signUploadedFile(id)", id);
	const b64 = await $.ajax('/SignTools?op=getuploaded&id=' + id);
	if (!b64 || b64.length === 0) {
		throw new Error('Неудается скачать файл ИД ' + id);
	}
	const sign = await SignAsync(b64, true, true, null, true);

	if (!sign) {
		return false;
	}

	var formData = new FormData();
	formData.append("op", "signuploaded");
	formData.append("id", id);
	formData.append("sign", sign);
	var result = await jQuery.ajax({
		url: "SignTools",
		type: 'POST',
		data: formData,
		contentType: false,
		processData: false
	});

	console.log("res", result);
	rrrrrrr = result;

	if (result) {
		if (result.success) {
			return true;
		} else {
			if (result.message) {
				await aAlert(result.message);
			} else {
				await aAlert("Неизвестная ошибка при подписании файла!");
			}
			return false;
		}
	} else {
		await aAlert("Неизвестная ошибка при подписании файла!!!");
		return false;
	}


	/*
	 return new Promise(function(resolve){
	 if (result) {
	 if (result.success) {
	 resolve(true);
	 } else if (result.message) {
	 alert(result.message);
	 resolve(false);
	 }
	 } else {
	 alert("Неизвестная ошибка при подписании файла!");
	 resolve(false);
	 }
	 });
	 */
}

/**
 * Проверка подписи файла
 * @param {type} orderId
 * @param {type} intervalObject
 * @param {type} callback - вызывается после успешной подписи
 * @param {type} type
 * @returns {undefined}
 */
async function checkSignGosKey(orderId, intervalObject, callback, type) {
	try {
		if (void 0 === intervalObject) {
			intervalObject = {interval: null};
		}
		if (void 0 === intervalObject?.start) {
			intervalObject.start = performance.now();
		}
		if (void 0 === intervalObject?.totalTime) {
			try {
				intervalObject.totalTime = parseInt(Conf.get("goskey_expire_minutes"));
			} catch (e) {
				intervalObject.totalTime = 5;
			}
		}
		clearInterval(intervalObject.interval);

		var leftSeconds = intervalObject.totalTime * 60 - (performance.now() - intervalObject.start) / 1000;
		if (leftSeconds <= 0) {
			if (jQuery(".signCover:visible").length > 0) {
				aAlert("Истекло время подписания документов!");
			}
			console.log("closeGoskeySignDialog from checkSignGosKey");
			jQuery(".signCover").hide().removeClass('forced');
			jQuery(".sendGosKeyFileMessage")?.data("aDialog")?.closeDialog();
			closeGoskeySignDialog();
			return;
		}

		var result = await jQuery.ajax({
			url: "SignTools?op=checkOrder&id=" + orderId + (type ? "&type=" + type : ""),
			type: 'GET'
		});
		if (result.statusId === 3 && typeof result.signData !== "undefined") { // успех
			rrr = result;
			closeGoskeySignDialog();
			if (typeof callback === "function") {
				callback(result.signData); // вызывается колбек из sign
			}
			jQuery(".signCover").hide();
			jQuery(".sendGosKeyFileMessage")?.data("aDialog")?.closeDialog();
		} else if (result.statusId === 4 || result.statusId === 5) {
			//Ошибка
			jQuery(".signCover").hide().removeClass('forced');
			jQuery(".sendGosKeyFileMessage")?.data("aDialog")?.closeDialog();
			$(".sign-test-form-gos-key .sc-2").removeClass("checking").addClass("sign-test__image_fail");
			const msg = "Не удалось подписать документ" + (result.statusName ? ": " + result.statusName : "");
			closeGoskeySignDialog();
			await aAlert(msg);
		} else {
			intervalObject.interval = setInterval(function () {
				checkSignGosKey(orderId, intervalObject, callback, type);
			}, 1000);
		}
	} catch (error) {
		eeeeer = error;
		console.log("ERR", error);
		await aAlert("Ошибка получения данных");
		jQuery(".signCover").hide();
		jQuery(".sendGosKeyFileMessage")?.data("aDialog")?.closeDialog();
		jQuery(".sendToGoskeyDialog.active")?.data("aDialog")?.closeDialog();
	}
}

/**
 * Подпись файлов
 * @param {type} files
 * @param {type} callback - вызывается после успешной подписи.
 * @param {type} snils
 * @returns {undefined}
 */
async function SignGosKeyFiles(files, callback, snils) {
	var intervalObject = {
		interval: null
	};
	window.cancelCheckGoskey = function () {
		clearInterval(intervalObject.interval);
	};
	var formData = new FormData();
	formData.append("op", "sendsignfiles");
	if (void 0 !== snils && snils !== false && snils.length !== 0) {
		formData.append("snils", snils);
	}
	for (var i = 0; i < files.length; i++) {
		formData.append("file_" + i, files[i]);
	}
	try {
		jQuery(".signCover").show();
		var result = await jQuery.ajax({
			url: "SignTools",
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false
		});
		var orderId = result?.orderId || result?.result?.orderId;
		if (typeof orderId !== "undefined") {
			intervalObject.interval = setInterval(function () {
				checkSignGosKey(orderId, intervalObject, callback);
			}, 1000);
			showGoskeySignDialog(result.packageName);
			return true;
		} else { // неудача
			const mes = result.message ? result.message : "Ошибка отправки данных в Госключ!";
			await aAlert(mes);
			jQuery(".signCover").hide();
			return false;
		}
	} catch (error) {
		handleWindowError("Ошибка SignGosKeyFiles: " + error.message, "", "", "", error);
		jQuery(".signCover").hide();
		await aAlert("Ошибка отправки документа");
		return false;
	}


}

function var_dump(toObj, tcSplit)
{
	if (!tcSplit)
		tcSplit = '\n';
	var lcRet = '';
	var lcTab = '    ';

	for (var i in toObj) // пїЅпїЅпїЅпїЅпїЅпїЅпїЅпїЅпїЅ пїЅ пїЅпїЅпїЅпїЅпїЅпїЅпїЅпїЅпїЅ пїЅпїЅпїЅпїЅпїЅпїЅпїЅ пїЅпїЅ пїЅпїЅпїЅпїЅпїЅпїЅпїЅ
		lcRet += lcTab + i + " : " + toObj[i] + tcSplit;

	lcRet = '{' + tcSplit + lcRet + '}';

	return lcRet;
}



function encode(sValue) {
	var text = "", Ucode, ExitValue, s;
	for (var i = 0; i < sValue.length; i++) {
		s = sValue.charAt(i);
		Ucode = s.charCodeAt(0);
		var Acode = Ucode;
		if (Ucode > 1039 && Ucode < 1104) {
			Acode -= 848;
			ExitValue = "%" + Acode.toString(16);
		} else if (Ucode === 1025) {
			Acode = 168;
			ExitValue = "%" + Acode.toString(16);
		} else if (Ucode === 1105) {
			Acode = 184;
			ExitValue = "%" + Acode.toString(16);
		} else if (Ucode === 32) {
			Acode = 32;
			ExitValue = "%" + Acode.toString(16);
		} else if (Ucode === 10) {
			Acode = 10;
			ExitValue = "%0A";
		} else {
			ExitValue = s;
		}
		text = text + String.fromCharCode(Acode);
	}
	return text;
}


function utf8encode(string) {
	//		string = string.replace(/\r\n/g,"\n");
	var utftext = "";

	for (var n = 0; n < string.length; n++) {

		var c = string.charCodeAt(n);

		if (c < 128) {
			utftext += String.fromCharCode(c);
		} else if ((c > 127) && (c < 2048)) {
			utftext += String.fromCharCode((c >> 6) | 192);
			utftext += String.fromCharCode((c & 63) | 128);
		} else {
			utftext += String.fromCharCode((c >> 12) | 224);
			utftext += String.fromCharCode(((c >> 6) & 63) | 128);
			utftext += String.fromCharCode((c & 63) | 128);
		}

	}

	return utftext;
}


function utf8decode(utftext) {
	var string = "";
	var i = 0;
	var c = c1 = c2 = 0;

	while (i < utftext.length) {

		c = utftext.charCodeAt(i);

		if (c < 128) {
			string += String.fromCharCode(c);
			i++;
		} else if ((c > 191) && (c < 224)) {
			c2 = utftext.charCodeAt(i + 1);
			string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
			i += 2;
		} else {
			c2 = utftext.charCodeAt(i + 1);
			c3 = utftext.charCodeAt(i + 2);
			string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
			i += 3;
		}

	}

	return string;
}



function base64_encode(data) {	// Encodes data with MIME base64
	//
	// +   original by: Tyler Akins (http://rumkin.com)
	// +   improved by: Bayron Guevara

	var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, enc = '';

	do { // pack three octets into four hexets
		o1 = data.charCodeAt(i++);
		o2 = data.charCodeAt(i++);
		o3 = data.charCodeAt(i++);

		bits = o1 << 16 | o2 << 8 | o3;

		h1 = bits >> 18 & 0x3f;
		h2 = bits >> 12 & 0x3f;
		h3 = bits >> 6 & 0x3f;
		h4 = bits & 0x3f;

		// use hexets to index into b64, and append result to encoded string
		enc += b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	} while (i < data.length);

	switch (data.length % 3) {
		case 1:
			enc = enc.slice(0, -2) + '==';
			break;
		case 2:
			enc = enc.slice(0, -1) + '=';
			break;
	}

	return enc;
}



function readUTF16String(bytes, bigEndian) {
	var ix = 0;
	var offset1 = 1, offset2 = 0;
	if (bytes.slice(0, 2) == "\xFE\xFF") {
		bigEndian = true;
		ix = 2;
	} else if (bytes.slice(0, 2) == "\xFF\xFE") {
		bigEndian = false;
		ix = 2;
	}

	if (bigEndian) {
		offset1 = 0;
		offset2 = 1;
	}

	var string = "";
	for (; ix < bytes.length; ix += 2) {
		var byte1 = bytes[ix + offset1].charCodeAt(0);
		var byte2 = bytes[ix + offset2].charCodeAt(0);
		var word1 = (byte1 << 8) + byte2;
		if (byte1 < 0xD8 || byte1 >= 0xE0) {
			string += String.fromCharCode(word1);
		} else {
			ix += 2;
			var byte3 = bytes[ix + offset1].charCodeAt(0);
			var byte4 = bytes[ix + offset2].charCodeAt(0);
			var word2 = (byte3 << 8) + byte4;
			string += String.fromCharCode(word1, word2);
		}
	}

	return string;
}

//TEMP!!!
function validateDate(s, error) {
	if (!error) {
		error = {};
	}
	var separators = ['\\.'];
	var bits = s.split(new RegExp(separators.join('|'), 'g'));
	var d = new Date(bits[2], bits[1] - 1, bits[0]);
	var ret = d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
	if (ret) {
		return true;
	}
	error.message = "Неверный формат даты!";
	return false;
}

function checkFormFields(formId, silent) {
	var x = true;
	var req_el;

	function iAlert(msg, el) {
		if (!silent) {
			aAlert(msg).then(() => {
				if (el) {
					el.focus();
				}
			});
		}
	}

	$("#" + formId + " input.datepicker:visible").each(function (i, el) {
		var val = $(el).val();
		if (val && !validateDate(val)) {
			if (!req_el)
				req_el = el;
			x = false;
		}
	});
	if (!x) {
		iAlert("Неправильный формат даты!", req_el);
		return false;
	}
	$("#" + formId + " input[type=text]").each(function (i, el) {
		$(el).blur();
		var val = $(el).val();
		if (typeof val === "string") {
			$(el).val(val.trim().replace(/\s+/g, ' '));
		}

	});
	$("#" + formId + " [required][type=checkbox]:not(:checked)").each(function (i, el) {
		if (!req_el)
			req_el = el;
		x = false;
	});
	if (!x) {
		iAlert("Не все обязательные галочки поставлены!", req_el);
		return false;
	}
	$("#" + formId + " input[inputmask]:visible").each(function (i, el) {
		if (!$(el).inputmask("isComplete") && $(el).val() !== "") {
			if (!req_el)
				req_el = el;
			x = false;
		}
	});

	$("#" + formId + " [required]").each(function (i, el) {
		if (!el.value) {
			if (!req_el)
				req_el = el;
			x = false;
		}
	});
	$("#" + formId + " [required_hidden]").each(function (i, el) {
		if (!el.value) {
			if (!req_el)
				req_el = el;
			x = false;
		}
	});
	if (!x) {
		iAlert("Не все обязательные поля заполнены!", req_el);
		return false;
	}
	$("#" + formId + " [isnum]").each(function (i, el) {
		if (x) {
			var val = el.value.replace(/ /gi, "").replace(",", ".");
			if (isNaN(val)) {
				iAlert("Неверное число!", el);
				x = false;
			} else {
				var type = $(el).attr("isnum");
				if (type == "natural" || type == "real") {
					if (val <= 0 && val != "") {
						iAlert("Нулевое значение недопустимо!", el);
						x = false;
					}
				}
			}
		}
	});
	if (!x) {
		return false;
	}

	$("#" + formId + " .filereq:visible").each(function (n, div) {
		if ($(".attfile:not(.removed)", div).length == 0) {
			iAlert("<div>Приложите документы:<br>" + $(".filetitle", div).html()) + "</div>";
//			mAlert("Приложите документы: " + $(".filetitle", div).html(), function () {
//				$('html, body').animate({scrollTop: $(div).offset().top + div.clientHeight - $(window).height() / 2}, 200);
//			});
			x = false;
			return false;
		}
	});
	if (!x) {
		return false;
	}

	var file_msg = "Не все требуемые файлы приложены!";
	$("#" + formId + " [file_required]:not([disabled])").each(function (i, el) {
		if (!el.value) {
			if ($(el).attr("data-miss-title")) {
				file_msg = $(el).attr("data-miss-title");
			}
			x = false;
			nof = el;
		}
	});
	if (!x) {
		iAlert(file_msg);
		return false;
	}


	return true;
}

function checkForm(formId, formName, checkUrl, isOper) {

	//console.log("checkForm", formId, formName, checkUrl, isOper);
	if (typeof (UPLOAD_FILS) !== "undefined" && !UPLOAD_FILS.isDone()) {
		aAlert("Дождитесь окончание загрузки файлов.");
		return false;
	}
	if (!isOper && !checkFormFields(formId))
		return false;

	if (checkUrl) {
		$.post(checkUrl + "?check=1", $("#" + formId).serialize(),
			function (d) {
				var data;
				if (typeof d === "object") {
					data = d;
				} else {
					data = eval("(" + d + ")");
				}
				if (data === null) {
					aAlert("Ошибка!!");
				}
				if (isOper && (data.errors || data.warnings)) {
					var msg = (data.errors ? "<b>Ошибки:</b><br>" + data.errors + "<br>" : "") + (data.warnings ? "<b>Предупреждения:</b><br>" + data.warnings + "<br>" : "") + "<span style='margin-top:15px'>Сохранить изменения?</span>";

					aConfirm(msg).
						then((answer) => {
							if (answer) {
								var form = document.getElementById(formId);
								if (!form) {
									aAlert("No form!");
									return;
								}
								form.onsubmit = "";
								form.submit();
							}
						});

					return false;
				} else if (data.errors) {
					aAlert(data.errors);
				} else {
					var form = document.getElementById(formId);
					if (!form) {
						aAlert("No form!");
						return;
					}
					form.onsubmit = "";
					form.submit();
				}
			});
		return false;
	} else {
		return true;
	}
}

/** Подписывает форму и отправляет данные
 *
 * @param {type} formId ID формы
 * @param {type} formName имя формы
 * @param {type} checkUrl URL для педварительной проверки (опц)
 * @returns {Boolean} false
 */
var signFormParams;
function signForm(formId, formName, checkUrl, noSign, onSign) {
	signFormParams = null;
	var form = $("#" + formId)[0];

	const confirmText = $(form).attr("data-confirm");
	if (confirmText) {
		aConfirm(confirmText).then((response) => {
			if (response) {
				sign();
			}
		});
	} else {
		sign();
	}

	/**
	 *  весь код после confirm внутри этой функции
	 *  (сделано чтобы дождаться асинхронный ответ внутри then)
	 * @returns {Boolean}
	 */
	function sign() {
		if (!checkFormFields(formId)) {
			return false;
		}

		if (checkUrl) {
			if (!isie) {
				//FF
				// MULTIPART!!!
				var formData = new FormData(form);
				formData.append('check', '1');
				$.ajax({
					type: 'POST',
					url: checkUrl,
					data: formData,
					cache: false,
					contentType: false,
					processData: false,
					success: function (d) {
						const data = setData(d);

						if (data === null) {
							aAlert("Ошибка!!");
						}
						if (data.noauth) {
							if (data.act == "bid") {
								signFormParams = {formId: formId, formName: formName, checkUrl: checkUrl};
								showAuthDialog();
								return;
							}
							if (data.act == "auth") {
								showAuthDialog();
								return;
							}
							if (data.act == "alert") {
								aAlert("Вы не авторизованы!");
								return;
							}
						}
						if (data.errors) {
							aAlert(data.errors);
						} else {
							warnBeforeSubmit(data);
						}
					},
					error: function (data) {
						aAlert("err");
					}
				});
			} else {

				$.post(checkUrl + "?check=1", $("#" + formId).serialize(),
					function (d) {
						const data = setData(d);

						if (data === null) {
							aAlert("Ошибка!!");
						}
						if (data.errors) {
							aAlert(data.errors);
						} else {
							warnBeforeSubmit(data);
						}
					});
			}
		} else {
			$.post("SignTools?formname=" + formName, $("#" + formId).serialize(),
				function (d) {
					const data = setData(d);

					if (data === null) {
						aAlert("Ошибка!!");
					}
					if (data.errors) {
						aAlert(data.errors);
					} else {
						warnBeforeSubmit(data);
					}
				});
		}
	}

	/**
	 * Устанавливаем значение data в ajax
	 * @param {type} data
	 * @returns {unresolved}
	 */
	function setData(data) {
		if (typeof data === "object") {
			return data;
		} else {
			return eval("(" + data + ")");
		}
	}

	function warnBeforeSubmit(data) {
		var attachFilesInput = form.querySelector("input[name='attach_files']");
		if (void 0 !== data?.attachFiles) {
			//Подписать файлы
			if (attachFilesInput === null || attachFilesInput === void 0) {
				attachFilesInput = document.createElement("input");
				attachFilesInput.type = "hidden";
				attachFilesInput.name = "attach_files";
			}
			attachFilesInput.value = data?.attachFiles;
			form.appendChild(attachFilesInput);
		} else {
			if (attachFilesInput !== null && attachFilesInput !== void 0) {
				attachFilesInput.remove();
			}
		}
		if (data.warnings) {
			aConfirm(data.warnings + "<br>Продолжить?").then((shouldKeep) => {
				if (shouldKeep) {
					submit(useGosKey ? data.text : data.form_txt);
				}
			});
		} else {
			submit(useGosKey ? data.text : data.form_txt);
		}
	}

	/**
	 * Публикование формы
	 * @param {type} dataToSign
	 * @returns {undefined}
	 */
	function submit(dataToSign) {
		if (noSign) {
			form.submit();
		} else {
			signSendForm(dataToSign, formId, onSign);
		}
	}

	return false;
}

function previewForm(formId, formName) {
	$.post("SignTools?fromname=xx", $("#" + formId).serialize(),
		function (data) {
			var w = window.open("about:blank");
			aAlert(data).then(() => {
				w.document.write(data);
			});
		});

	return false;

}


function getFileInfoFromName(name) {
	var re = /(?:\.([^.]+))?$/;
	var ext = re.exec(name)[1].toLowerCase();
	var result = {
		ext: ext,
		type: void 0,
		gosKeyAllowed: false,
		fileExtChange: false
	};
	var type = void 0;
	const typesAr = Conf.get("goskey_allowed_ext").split(",");
	const typesChangeAr = Conf.get("goskey_allowed_ext_for_change").split(",");
	if (ext === "jpeg") {
		ext = "jpg";
	}
	switch (ext) {
		case "docx":
			type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
			break;
		case "xlsx":
			type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
			break;
		case "pdf":
			type = "application/pdf";
			break;
		case "png":
			type = "image/png";
			break;
		case "txt":
		case "html":
			type = "text/plain";
			break;
		case "jpeg":
		case "jpg":
			type = "image/jpeg";
			break;
		case "zip":
			type = "application/zip";
			break;
		case "rar":
			type = "application/rar";
			break;
		default:
			type = void 0;
			break;
	}
	result.type = type;
	result.gosKeyAllowed = typesAr.includes(ext) || typesChangeAr.includes(ext);
	result.fileExtChange = typesChangeAr.includes(ext);
	return result;
}

window.cadesplugin_extension_loaded_callback = function () {
	hasPlugin = true;
};

/*
 * Очищаем сохраненный для выбора сертификат
 */
function clearStoredCertificate() {
	lastUsedCert = null;
	localStorage.removeItem('__storedSelectedCertsV2'); // удаляем ошибочный сертификат из хранилища
	//localStorage.removeItem('__storedSelectedCerts');
}
